module.exports = __webpack_public_path__ + "img/partnership_process_05.2ea98aa1.png";